import { Badge, Text } from '@thefarmersfront/kitchen';

import { useGetSmartSearch } from '~/hooks/smart-search';
import { useSmartSearchStore } from '~/store/common';

import SmartSearchContactBanner from './SmartSearchContactBanner';
import SmartSearchError from './SmartSearchError';
import SmartSearchFAQ from './SmartSearchFAQ';
import SmartSearchHeader from './SmartSearchHeader';
import SmartSearchInput from './SmartSearchInput';
import SmartSearchLoading from './SmartSearchLoading';
import SmartSearchResult from './SmartSearchResult';

import styles from './SmartSearchContent.module.scss';

const SmartSearchContent = () => {
  const submittedQuery = useSmartSearchStore((state) => state.submittedQuery);
  const { data, isLoading, isError, error } = useGetSmartSearch(submittedQuery);

  const showTip = !submittedQuery;

  const renderBody = () => {
    if (!submittedQuery) return <SmartSearchFAQ />;

    if (isLoading) return <SmartSearchLoading />;

    if (isError) {
      const errorMessage = error?.message;
      return <SmartSearchError errorMessage={errorMessage} />;
    }

    if (data) return <SmartSearchResult data={data} />;

    return null;
  };

  return (
    <div className={styles['smart-search-content']}>
      <SmartSearchHeader />
      <SmartSearchInput />
      {showTip && (
        <div className={styles['tip']}>
          <Badge size="small" color="primary" variant="light">
            TIP
          </Badge>
          <Text size="medium" color="tertiary">
            질문을 구체적으로 할수록 더 정확한 답변을 받을 수 있습니다.
          </Text>
        </div>
      )}
      <div className={styles['body']}>
        {renderBody()}
        {data && <SmartSearchContactBanner />}
      </div>
    </div>
  );
};

export default SmartSearchContent;
